/**
 * `GET /api/hexa?accountId=` — the account-wide HEXA rollup (REV20 — docs/specs/REV20-hexa-page.md),
 * mirroring `lib/pitched.ts`'s `usePitchedForAccount`. Read-only: node edits still go through
 * `lib/characterProgress.ts`'s per-character HEXA mutations (`useUpsertHexaNode`/
 * `useDeleteHexaNode`) — `HexaSection` (reused wholesale on the character tab) already owns those.
 */
import { useQuery } from '@tanstack/react-query';
import { apiGet } from './api';
import type { HexaNodeDto, HexaStatNodeDto } from './characterProgress';

export interface HexaCharacterDto {
  characterId: number;
  nodes: HexaNodeDto[];
  /** REV22 Fix 2 (docs/specs/REV22-hexa-stat-and-merged-masteries.md) — always all 3 HEXA Stat nodes. */
  statNodes: HexaStatNodeDto[];
}

export function hexaForAccountQuery(accountId: number) {
  return {
    queryKey: ['hexa', accountId] as const,
    queryFn: ({ signal }: { signal: AbortSignal }) =>
      apiGet<HexaCharacterDto[]>(`/api/hexa?accountId=${accountId}`, signal),
  };
}

export function useHexaForAccount(accountId: number | null) {
  return useQuery({
    ...hexaForAccountQuery(accountId ?? -1),
    enabled: accountId !== null,
  });
}
